import React from 'react';
import type { ToolUseBlock, ToolResultBlock } from '../../store/chatStore';
import { ToolParameterView } from './ToolParameterView';
import { ToolResultView } from './ToolResultView';
import { DebugView } from './DebugView';

interface ToolExecutionItemProps {
  toolUse: ToolUseBlock;
  result?: ToolResultBlock;
  viewMode: 'parameters' | 'result' | 'debug';
  getRenderer: (result: ToolResultBlock) => React.ComponentType<{
    result: ToolResultBlock;
    toolUse: ToolUseBlock;
  }>;
}

export const ToolExecutionItem: React.FC<ToolExecutionItemProps> = React.memo(
  ({ toolUse, result, viewMode, getRenderer }: ToolExecutionItemProps) => {
    if (!result && viewMode === 'result') {
      return null;
    }

    switch (viewMode) {
      case 'parameters':
        return <ToolParameterView toolUse={toolUse} />;
      case 'result':
        return (
          <ToolResultView
            result={result!}
            toolUse={toolUse}
            getRenderer={getRenderer}
          />
        );
      case 'debug':
        return <DebugView toolUse={toolUse} result={result} />;
      default:
        return null;
    }
  },
);

ToolExecutionItem.displayName = 'ToolExecutionItem';
